export const published = [
    {
        image: "http://researchdiscourse.org/wp-content/uploads/2021/05/January-March-2018-Cover.png",
        date: "January-March 2018",
    },
    {
        image: "http://researchdiscourse.org/wp-content/uploads/2021/05/October-December-2017-cover.png",
        date: "January-March 2018",
    },
    {
        image: "http://researchdiscourse.org/wp-content/uploads/2021/05/July-September-2017-cover.png",
        date: "January-March 2018",
    },
    {
        image: "http://researchdiscourse.org/wp-content/uploads/2021/05/April-June-2017-cover.png",
        date: "January-March 2018",
    },
    {
        image: "http://researchdiscourse.org/wp-content/uploads/2021/05/January-March-2017Cover.png",
        date: "January-March 2018",
    },
    {
        image: "http://researchdiscourse.org/wp-content/uploads/2021/05/October-December-2016-pdf.jpg",
        date: "January-March 2018",
    },
];
